import React, {useState} from 'react';
import { Outlet, useParams, useSearchParams } from "react-router-dom";
import {
    Box,
} from '@mui/material';
import Header from "./components/Header";
import Breadcrumbs from "./components/Breadcrumbs";
import Footer from "./components/Footer";
import lobJSON from "../assets/lobBranding.json"
import LocalStorageService from '../services/localStorage';
import './Main.css';

const localStorageService = LocalStorageService.getService();

const Main = (props) => {

  const { orgId } = useParams();
  const [searchParams] = useSearchParams();

  const lob = searchParams.get("lob");

  const [loading, setLoading] = useState(true);
  const [brandingInfo, setBrandingInfo] = useState(null);
  React.useEffect(() => {

    setLoading(true);

    if (lobJSON && orgId && lob) {

      // Convert to lowercase array for comparison
      let lobArray = lob.split(',').map(l => l.trim().toLowerCase());


      // Priority logic
      let filterLob;
      if (lobArray.includes('bcbs al')) {
        filterLob = lobJSON[orgId].find(l => lobArray.includes("bcbs al"));

      } else {

        // Choose the first matching LOB in lobList that appears in lobArray
        filterLob = lobJSON[orgId].find(l => lobArray.includes(l?.title.toLowerCase()));
      }
      
      if (typeof(filterLob) ==='undefined') {
        lobArray=['bcbs al'];
        filterLob = lobJSON[orgId].find(l => lobArray.includes("bcbs al"));
      }


      setBrandingInfo(filterLob);
      localStorageService.setBrandingInfo(JSON.stringify(filterLob));
      setLoading(false);

    }
    else {

      if (Object.keys(lobJSON) && Object.keys(lobJSON).length>0) {
        let lobBranding = lobJSON[Object.keys(lobJSON)[0]].filter(i=>i.title.toLowerCase()==="default");

        setBrandingInfo(lobBranding[0]);

        localStorageService.setBrandingInfo(JSON.stringify(lobBranding[0]))

        setLoading(false);
      }

      
    }
    
  }, [orgId, lob]);

  
  if (loading || !brandingInfo) {
    return <div>Loading...</div>;
  }

  return (
    <Box component="section" className="mainLayoutBox">
      <Header isQuestionnaire={props?.isQuestionnaire} />
      <Breadcrumbs />
      <main>
        <Outlet />
      </main>
      <Footer />
    </Box>
  );
};

Main.propTypes = {
  isQuestionnaire: false,
};


export default Main;
